// Import the functions you need from the SDKs you need
import {initializeApp} from "firebase/app";
import {getAnalytics} from "firebase/analytics";
import {getAuth} from 'firebase/auth'
import {getFirestore} from 'firebase/firestore'
import {getStorage} from 'firebase/storage'
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
// buraz.colombia@gmail.com
const firebaseConfig = {
    apiKey: "AIzaSyBEwEvCdaLpVraSKc0HNCb2QbdXBJ5vjPc",
    authDomain: "grupoburaz.firebaseapp.com",
    projectId: "grupoburaz",
    storageBucket: "grupoburaz.firebasestorage.app",
    messagingSenderId: "433010130352",
    appId: "1:433010130352:web:8e20d606b0afe9cf55aa75",
    measurementId: "G-3WZ05ZTEB6"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);

export const auth = getAuth(app)
export const fire = getFirestore(app)
export const storage = getStorage(app)